<template>
  <!-- The flag-petition-link CSS class is to allow Campact and any other orgs that want to customize the styling for this
       button via custom CSS, to make it simpler to build a selector -->
  <a v-if="useCustomUrlForFlagging" class="flag-petition-link small-text text-start ps-0" :href="customUrlForFlagging"
     rel="nofollow">
    <i class="icon-flag" />

    <!-- We wrap this text in a span per Campact's request so they can customize the text via CSS shenanigans.
         We intentionally do not make this text customizable for customers in general, because we do not think
         there is a good-idea use case for customizing the text. -->
    <span class="flag-petition-label">{{ i18n.t('public.petitions.flag.flag_this') }}</span>
  </a>
  <link-button v-else class="flag-petition-link small-text text-start ps-0" @click="showModalForm">
    <i class="icon-flag" />
    <span class="flag-petition-label">{{ i18n.t('public.petitions.flag.flag_this') }}</span>
  </link-button>

  <modal-action-form v-if="showFlagForm" :show-on-mount="true" modal-id="modalFlagForm"
                     size="md" :title="i18n.t('public.petitions.flag.modal_heading')" :captcha-action="captchaAction"
                     :submit-action="createFlagAction" :submit-text="i18n.t('public.petitions.flag.flag_petition')"
                     :use-bot-protection-if-available="true" @clear="clear">
    <template #body>
      <div class="d-grid gap-3">
        <p class="mb-0" v-html="flagCreationDescriptionContent" />

        <text-input :label="i18n.t('public.petitions.flag.form.email')" :readonly="!canEditEmail" input-id="flag-email"
                    :required="true" :value="email" :validation-errors="validationErrors.email"
                    @changed="updateEmail" />

        <div>
          <p class="mt-4">
            {{ i18n.t('public.petitions.flag.form.give_reason') }}
          </p>

          <text-input :label="i18n.t('activerecord.attributes.petition_flag.reason')" :required="true"
                      input-id="flag-reason" :multiline="true" rows="5" :validation-errors="validationErrors.reason"
                      @changed="updateReason" />
        </div>
      </div>
    </template>
  </modal-action-form>

  <toast v-if="flagSuccessfullyCreated" kind="success">
    <template #message-content>
      {{ i18n.t('public.petitions.flag.success_create') }}
    </template>
  </toast>
</template>

<script>
import ajax from '@/helpers/ajax'
import LinkButton from '@/components/buttons/link-button'
import ModalActionForm from '../components/modal-action-form'
import TextInput from '@/components/inputs/text-input'
import Toast from '@/components/toast'

export default {
  components: { LinkButton, ModalActionForm, TextInput, Toast },

  props: {
    captchaAction: {
      type: String,
      required: true
    },
    canEditEmail: {
      type: Boolean,
      required: true
    },
    flagCreationDescriptionContent: {
      type: String,
      required: true
    },
    flagCreationUrl: {
      type: String,
      required: true
    },
    memberEmail: {
      type: String,
      required: false
    },
    useCustomUrlForFlagging: {
      type: Boolean,
      required: true
    },
    customUrlForFlagging: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      email: this.memberEmail,
      flagSuccessfullyCreated: false,
      reason: '',
      showFlagForm: false,
      validationErrors: []
    }
  },

  methods: {
    clear() {
      this.email = this.memberEmail
      this.reason = ''
      this.showFlagForm = false
    },

    createFlagAction({friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken}) {
      const flagData = {
        email: this.email,
        reason: this.reason
      }

      return new Promise((resolve, reject) => {
        ajax.post({
          url: this.flagCreationUrl,
          data: {
            flag: flagData,
            friendly_captcha_solution: friendlyCaptchaSolution,
            hcaptcha_response: hcaptchaResponse,
            recaptcha_token: recaptchaToken,
            turnstile_token: turnstileToken
          },
          successHandler: () => {
            this.showFlagForm = false
            this.flagSuccessfullyCreated = true
            this.validationErrors = []
            resolve()
          },
          errorHandler: ({ info }) => {
            this.validationErrors = info.errors

            // Prevent the modal from closing
            reject(this.i18n.t('public.petitions.flag.failed_create'))
          }
        })
      })

    },

    showModalForm() {
      this.flagSuccessfullyCreated = false
      this.validationErrors = []
      this.showFlagForm = true
    },

    updateEmail(newEmail) {
      this.email = newEmail
    },

    updateReason(newReason) {
      this.reason = newReason
    }
  }
}
</script>
